/**
 * Global speech bus — lets any part of the app tell every SpeakButton
 * currently mounted to shut up. Also self-called by a SpeakButton right
 * before it starts a new playback, so two Umbra voices never overlap.
 */
const listeners = new Set();

export const subscribeStop = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

export const notifyStopAllSpeech = () => {
  listeners.forEach((fn) => {
    try { fn(); } catch { /* listener already unmounted — safe to ignore */ }
  });
};
